import type { ReactNode } from "react";
import type { PrizeDrop } from "@/campaigns/modules/prizedrop/types";
import { PrizeDropRow } from "./prizedrop-row";
import { StatFigure } from "@/components/campaigns/campaign-shell/campaign-sections";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { totalRemaining } from "@/campaigns/modules/prizedrop/types";
import { useTranslation } from "react-i18next";

/** Sidebar copy for the shared HowToWinCard (English default; translated via
 *  `prizedrop.howToWin` where it's rendered). */
export const PRIZEDROP_HOW_TO_WIN =
  "Only a real money bet can trigger a prize, and the more you bet, the higher your chances are.";

/** The one number a player wants: how many prizes are still to be won. The lead stat of the
 *  page on phones (above the tiers), a sidebar card on desktop, the head of the overlay's dock
 *  panel — where `children` (the join state) sits under the figure. */
export const RemainingPrizeDrops = ({
  prizeDrop,
  density = "default",
  className,
  children,
}: {
  prizeDrop: PrizeDrop;
  /** See `StatFigure`. */
  density?: "default" | "dock";
  className?: string;
  children?: ReactNode;
}) => {
  const { t } = useTranslation();
  return (
    <Card
      title={t("prizedrop.remaining", "Remaining prize drops")}
      className={cn("flex flex-col items-start gap-3", className)}
      titleRowClassName="mb-0 w-full"
    >
      <StatFigure density={density}>
        {totalRemaining(prizeDrop).toLocaleString()}
      </StatFigure>
      {children}
    </Card>
  );
};

/** Primary tab — the list of prize tiers. */
export const PrizeDropList = ({ prizeDrop }: { prizeDrop: PrizeDrop }) => (
  <div className="flex w-full flex-col items-center gap-3 overflow-hidden">
    {prizeDrop.prizes.map((prize) => (
      <PrizeDropRow key={prize.id} prize={prize} />
    ))}
  </div>
);
